import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DataService } from 'src/app/data.service';
import { LanguageService } from 'src/app/language.service';
import { Destroyable } from 'src/app/shared/services/destroyable';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';
import { LocalStorageService } from 'src/app/shared/services/storage/local-storage.service';
import { KEYS } from 'src/app/shared/utils/constants/storage.constants';

@Component({
  selector: 'app-myaha-explore',
  templateUrl: './myaha-explore.component.html',
  styleUrls: ['./myaha-explore.component.scss'],
})
export class MyahaExploreComponent
  extends Destroyable
  implements OnInit, OnDestroy
{
  @Input() isFromLanguageSelection: boolean = false;
  @Input() isFromSettings: boolean = false;
  @Input() selectedProfileIndex: number;

  currentLang: string = 'en'; // default fallback

  constructor(
    private readonly navService: NavigationLibraryService,
    private readonly dataService: DataService,
    private readonly languageService: LanguageService,
    private readonly localStorage: LocalStorageService
  ) {
    super();
  }

  ngOnInit(): void {
    this.currentLang = this.languageService.currLang;
    this.dataService.myahaContentIndex = null;
    if (!this.isFromLanguageSelection && !this.isFromSettings) {
      // this.navService.focusContainer('explore-container', false, 0, false);
    }
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  onExploreClick() {
    this.localStorage.setItem(KEYS.FRESH_LAUNCH, 'true');
    this.dataService.emitVerticalMenuEvent({
      action: 'no-action',
      data: {
        tabId: this.dataService.homeTab,
      },
    });
  }

  onExploreLeft() {
    //temporary add of left action
    this.dataService.emitVerticalMenuEvent({
      action: 'open',
    });
  }

  onExploreUp() {
    this.navService.setIndexContainer('top-panel', this.selectedProfileIndex);
    this.navService.focusContainer(
      'top-panel',
      true,
      this.selectedProfileIndex,
      true
    );
  }
}
